import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { SharedService, LottoBetpanelService, ConfigService, betpanel, User, betticket } from 'baseline-lib';
import { Global } from '../../../../global/global';
import { CustomToast } from '../../services/custom-toast';
import { HomePage } from '../../../home/home/home';

/**
 * Generated class for the BetHistoryDetailsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'bet-history-details',
  templateUrl: 'bet-history-details.html'
})
export class BetHistoryDetailsComponent implements OnInit{

  @Input() _ticketList: betticket[];
  _panels: any[] = [];
  mapTickedIdvsPanels: Map<any, any[]>;
  current: number = -1;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public globalData : Global,public loadingCtrl : LoadingController,
    public toast : CustomToast, public _sharedServices : SharedService,
    public _lottoBetpanelService: LottoBetpanelService, public _configService : ConfigService) {
    console.log("ticketlist-->",this._ticketList);
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BetHistoryDetailPage');
    console.log(this._ticketList);
  }

  ngOnInit(){
    this.current = -1;
    this._panels = [];
    this.mapTickedIdvsPanels = new Map<any, any[]>();     
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes._ticketList) {
      
    }
    console.log(this._ticketList);
  }
  getBGcolourTkt(ticket) {    
    var status = ticket.status;
    if (status == "Result yet come") {
      return 'rgba(212, 204, 255, 0.62)';
    } else if (status == "Winning") {
      return 'rgb(203, 255, 203)';
    } else if (status == "Not Winning") {
      return 'rgb(251, 226, 226)';
    }
    else if (status == "Cancelled") {
      return 'rgb(247, 238, 207)';
    }
    else if (status == "Pay blocked") {
      return 'rgb(247, 222, 198)';
    }
  }

  clickToggle(ticketNo){
    const loader = this.loadingCtrl.create({
      content: "Please Wait",
    });

    let authuser = this.globalData.authUser;
    if (authuser == null || authuser == undefined) {
      loader.dismiss();
      this.toast.showError("Login to continue ...!");
      return;
    }
    this._panels = [];
    this._panels = this.mapTickedIdvsPanels.get(ticketNo);
    console.log(this.mapTickedIdvsPanels);
    if (this._panels == undefined || this._panels.length == 0 || this._panels == null) {
      loader.present();
      let datareq = { "tn": null }
      datareq.tn = ticketNo;
      this._sharedServices.getPanelsListByTktNo(datareq, authuser.tokenNo)
        .subscribe(
        data => {
          loader.dismiss();
          var _panelModels: betpanel[] = [];
          // var _selections: Selection[] = [];
          data.pli.forEach(_pli => {
            var _panelmodel = new betpanel();
            _panelmodel.parse(_pli);
            // _ticketList.sli.forEach(selection => {
            //   _panelmodel.selections.push(selection);
            // }
            // );
            _panelModels.push(_panelmodel);
          });

          this._panels = _panelModels;
          this.mapTickedIdvsPanels.set(ticketNo, this._panels);
        }, error => {
          loader.dismiss();
          if(error.errorCode == 401){  // Logout
            this.toast.showError("Please Login to continue!");
            localStorage.clear(); //logout;
            this.globalData.selectedMenu = "home";
            this.globalData.isLoggedIn = false;
            this.globalData.authUser = new User();
            this._lottoBetpanelService.clearallBetPanels();
            if(this._sharedServices.timerSub)
              this._sharedServices.timerSub.unsubscribe();
            if(!this._configService.isplayerLogin())
              this.navCtrl.setRoot(HomePage);
            this._sharedServices.loginSubject.next(false);
          }else{
            this.toast.showError(error.message);
          }
        });
    } else {
        return;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/bet-history/bet-history-details/bet-history-details.ts